import { Badge, Card, ListGroup } from 'react-bootstrap';
import { Fragment, useMemo } from 'react';
import { cpkBadgeVariant, fmtNum } from '../../Services/processo/dashboardProcessoUtils';

const ControleDashboardCard = ({
    nomePlanoSelecionado,
    controleOptions,
    selectedControleId,
    setSelectedControleId,

}) => {

    const groupedOptions = useMemo(() => {
        const groups = {};
        controleOptions.forEach(opt => {
            const op = opt.operacao || 'Geral';
            if (!groups[op]) groups[op] = [];
            groups[op].push(opt);
        });
        return groups;
    }, [controleOptions]);

    return (
        <Card className="h-100 d-flex flex-column shadow-sm">
            <Card.Header className="bg-white fw-bold text-truncate" title={nomePlanoSelecionado}>
                Controles — {nomePlanoSelecionado}
            </Card.Header>

            <Card.Body className="p-0 overflow-auto flex-grow-1 custom-scrollbar" style={{ maxHeight: '600px' }}>
                <ListGroup variant="flush">
                    {controleOptions.length === 0 && (
                        <ListGroup.Item className="text-muted text-center py-3">
                            Nenhum controle encontrado.
                        </ListGroup.Item>
                    )}
                    {Object.entries(groupedOptions).map(([operacao, items]) => (
                        <Fragment key={operacao}>
                            <ListGroup.Item className="bg-light fw-bold text-uppercase small text-muted py-1 ps-3">
                                {operacao}
                            </ListGroup.Item>
                            {items.map((o) => (
                                <ListGroup.Item
                                    key={o.value}
                                    action
                                    active={String(selectedControleId) === String(o.value)}
                                    onClick={() => setSelectedControleId(o.value)}
                                    className="d-flex justify-content-between align-items-center border-0 border-bottom"
                                >
                                    <div className="text-truncate pe-2" title={o.label}>
                                        <div className="fw-semibold text-truncate">
                                            {o.nomeParametro || o.label}
                                        </div>
                                        <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                            ID: {o.value}
                                        </small>
                                    </div>
                                    <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                        {(o.qtdFora > 0 || o.statAlert) && (
                                            <Badge 
                                                bg="danger" 
                                                pill 
                                                title={o.qtdFora > 0 
                                                    ? `${o.qtdFora} registro(s) fora de especificação` 
                                                    : "Alerta estatística"}
                                            >
                                                {o.qtdFora > 0 ? o.qtdFora : '!'}
                                            </Badge>
                                        )}
                                        <Badge
                                            bg={cpkBadgeVariant(o.cpk)}
                                            pill
                                            title={`Cpk: ${fmtNum(o.cpk, 3)}`}
                                            style={{ minWidth: '45px', textAlign: 'center' }}
                                        >
                                            {fmtNum(o.cpk, 2)}
                                        </Badge>
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </Fragment>
                    ))}
                </ListGroup>
            </Card.Body>
        </Card>
    );
};

export default ControleDashboardCard;